export default __webpack_public_path__ + "static/media/No3.e9f1e7d9.png";